var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0D8050",
    d: "M10.657 0h1.375v1.852c2.318 0 4.635.004 6.952-.007.391.016.822-.012 1.162.222.238.343.21.778.227 1.171-.012 4.019-.007 8.035-.005 12.051-.012.674.063 1.361-.079 2.026-.092.481-.67.493-1.058.51-2.398.006-4.798-.006-7.199 0v2.082h-1.437C7.067 19.267 3.532 18.674 0 18.056V1.854C3.553 1.236 7.106.627 10.657 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8FA",
    d: "M12.032 2.546h7.64V17.13h-7.64v-1.39h1.852v-1.62h-1.852v-.926h1.852v-1.62h-1.852v-.926h1.852v-1.62h-1.852v-.926h1.852v-1.62h-1.852v-.926h1.852v-1.62h-1.852v-1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#238C2C",
    d: "M14.81 3.935h3.24v1.62h-3.24v-1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.856 6.104c.524-.037 1.05-.07 1.575-.095a479.643 479.643 0 0 1-1.869 3.794c.637 1.297 1.288 2.584 1.926 3.88-.557-.033-1.113-.067-1.67-.107-.394-.965-.874-1.898-1.156-2.907-.315.94-.764 1.826-1.125 2.748a55.598 55.598 0 0 1-1.52-.049c.594-1.164 1.168-2.338 1.782-3.495-.521-1.192-1.093-2.361-1.63-3.547.51-.03 1.018-.06 1.528-.088.345.906.722 1.799 1.007 2.727.305-.984.761-1.91 1.152-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#238C2C",
    d: "M14.81 6.481h3.24v1.62h-3.24v-1.62zm0 2.547h3.24v1.62h-3.24v-1.62zm0 2.546h3.24v1.62h-3.24v-1.62zm0 2.546h3.24v1.62h-3.24v-1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B95D6",
    d: "M34 5.058V4.1C35.5 5.23 38.52 6 42 6c3.49 0 6.51-.77 8-1.9v5.4c0 1.38-3.58 2.5-8 2.5-1.688 0-3.253-.163-4.544-.442l1.051-1.05a.712.712 0 0 0 .207-.508c0-.2-.078-.379-.207-.507l-4.286-4.286a.703.703 0 0 0-.221-.15zm2.69 7.266c1.49.425 3.325.676 5.31.676 3.49 0 6.51-.77 8-1.9v5.4c0 1.38-3.58 2.5-8 2.5s-8-1.12-8-2.5v-1.558a.703.703 0 0 0 .221-.15l2.469-2.468zM42 5c-4.41 0-8-1.12-8-2.5S37.58 0 42 0s8 1.12 8 2.5S46.42 5 42 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C7080",
    fillOpacity: 0.5,
    d: "M34.65 9.493l-4.286-4.286a.716.716 0 0 0-1.014 1.014l3.071 3.065h-9.707A.716.716 0 0 0 22 10c0 .393.321.714.714.714h9.707l-3.064 3.065a.69.69 0 0 0-.214.507.716.716 0 0 0 1.221.507l4.286-4.286a.712.712 0 0 0 .207-.507c0-.2-.078-.379-.207-.507z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.1285f0303cce79413a684606f51fa4c9.svg";
export { ForwardRef as ReactComponent };